import type { ICandidateSchemaWithOptions, ICandidateSchemaWithOptionsNotEditable } from "@bbj-types/organisation";
import { useCallback } from "react";
import { axiosSettings } from "./axios";

export * from "./uploadCerTemplate";
export * from "./postOrganisationFilterView";
export * from "./deleteOrganisationFilterView";
export * from "./getOrganisationsV2";
export * from "./getOrganisation";
export * from "./updateOrganisation";
export * from "./deleteOrganisationTeam";
export * from "./getUserAccess";
export * from "./uploadOrganisationTemplate";

export const useGetCandidateSchemas = () => {
  return axiosSettings<ICandidateSchemaWithOptions[]>(
    {
      url: "/v2/organisations/candidateSchema",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );
};

interface ICandidateSchemaSettingCreationError {
  candidateSchema: string;
  value: string;
  code: number;
}

export interface IPatchCandidateSchemasResponse {
  candidateSchemas: ICandidateSchemaWithOptions[];
  errors: ICandidateSchemaSettingCreationError[];
}

export const usePatchCandidateSchemas = () => {
  const [state, execute, cancel] = axiosSettings<IPatchCandidateSchemasResponse>(
    {
      url: "/v2/organisations/candidateSchema",
      method: "PATCH",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (candidateSchemas: ICandidateSchemaWithOptionsNotEditable[]) => {
      return execute({ data: candidateSchemas });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export interface ICandidateSchemaAutocompleteParams {
  search?: string;
  limit?: number;
}

export const useGetCandidateSchemasAutocomplete = () => {
  const [state, execute, cancel] = axiosSettings(
    {
      url: "/v2/organisations/candidateSchema/autocomplete",
      method: "get",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (params: ICandidateSchemaAutocompleteParams) => {
      return execute({
        params,
      });
    },
    [execute]
  );
  return [state, callback, cancel] as const;
};
